// ============================================
//   NEURORA INNOVATIONS — BRAND CONSTANTS
//   Single source of truth for all brand,
//   contact, pricing, and company data.
//   Never hardcode these values in components.
// ============================================

export const BRAND = {
    name: 'Neurora Innovations',
    shortName: 'Neurora',
    tagline: 'Software, shipped. Robotics, coming.',
    mission: 'Building technology around African businesses—not forcing African businesses to adapt to foreign technology.',
    email: 'neurora4@gmail.com',
    phone: '+254 793 764 742',
    location: 'Nairobi, Kenya',
    founded: '2024',
};

export const ADOPTAFRICA = "A.D.O.P.T AFRICA"

export const SOCIAL = {
    linkedin: 'https://linkedin.com/company/neurora-innovations',
    twitter:  'https://twitter.com/neurora_hq',
    github:   'https://github.com/neurora-innovations',
    instagram: 'https://instagram.com/neurora_hq',
    facebook:  'https://facebook.com/neurorainnovations',
};

export const ADOPT = {
  name: ADOPTAFRICA ,
  fullName: 'A.D.O.P.T AI',
  tagline: 'Your Business. Powered by AI.',
//   url: 'https://adoptafrica.ai',
//   url: 'https://adoptai.co',
  url: 'https://adoptafrica.co',
  description: 'A managed AI operations platform that diagnoses, deploys, and manages AI tools for African businesses.',
};

export const CONSULTATION = {
    fee: {
        KES: 2000,
        USD: 15,
        EUR: 14,
    },
    duration: '60 minutes',
    description: 'A fully prepared, personalized strategy session. We research your business before we meet.',
    };

export const CURRENCIES = {
    KES: { symbol: 'KES', rate: 1 },
    USD: { symbol: '$',   rate: 0.0077 },
    EUR: { symbol: '€',   rate: 0.0071 },
};

export const SERVICES = {
    core: [
        {
            id: 'foundational-builds',
            name: 'Custom Business Software',
            description: 'CRM, inventory management, booking systems, and marketing websites — the operational backbone of your business.',
            price: { min: 150000, max: 300000 },
            status: 'available',
        },
        {
        id: 'ecommerce',
            name: 'E-commerce',
            description: 'Online stores built to sell — from simple product catalogs to advanced multi-vendor platforms.',
            tiers: [
                { name: 'Basic',    price: { min: 80000,  max: 200000 } },
                { name: 'Standard', price: { min: 180000, max: 300000 } },
                { name: 'Advanced', price: { min: 300000, max: 500000 } },
            ],
            status: 'available',
        },
        {
            id: 'mobile-apps',
            name: 'Mobile Apps',
            description: 'Reach customers and empower your workforce with custom mobile apps for Android and iOS.',
            tiers: [
                { name: 'Basic',    price: { min: 200000, max: 350000 } },
                { name: 'Standard', price: { min: 350000, max: 600000 } },
                { name: 'Advanced', price: { min: 600000, max: 1000000 } },
            ],
            status: 'available',
        },
        {
            id: 'ai-automation',
            name: 'AI & Automation',
            description: 'Automate repetitive work, reduce costs, and increase productivity with intelligent AI solutions.',
            price: { min: 350000, max: 600000 },
            status: 'available',
        },
        {
            id: 'api-integrations',
            name: 'API Integrations',
            description: 'Connect your existing software so your business runs as one connected system.',
            price: { min: 60000, max: 150000 },
            status: 'available',
        },
        {
            id: 'mpesa-payments',
            name: 'M-Pesa & Payments Integration',
            description: 'Daraja API integration for M-Pesa payments — the payment rail every Kenyan business needs.',
            price: { min: 80000, max: 150000 },
            status: 'available',
        },
        {
            id: 'dashboards',
            name: 'Dashboards & Reporting',
            description: 'Turn business data into clear insights that help you make faster, better decisions.',
            price: { min: 120000, max: 200000 },
            status: 'available',
        },
        {
            id: 'saas-mvp',
            name: 'SaaS Product Development',
            description: 'From idea to deployed product. We design, build, and ship your SaaS platform end to end.',
            price: { min: 700000, max: 1200000 },
            status: 'available',
        },
        {
            id: 'maintenance',
            name: 'Ongoing Maintenance & Support',
            description: 'Monthly retainer for updates, fixes, performance monitoring, and technical support.',
            price: { min: 15000, max: 30000 },
            isMonthly: true,
            status: 'available',
        },

        {
            id: 'seo',
            name: 'Total Digital Visibility',
            description: 'Full SEO, AEO and GEO implementation — from technical setup to AI search visibility. Your business found on Google, Maps, and AI assistants like ChatGPT.',
            tiers: [
            { name: 'Basic SEO', price: { min: 15000, max: 15000 } },
            { name: 'Advanced SEO', price: { min: 25000, max: 25000 } },
            { name: 'AEO/GEO Add-on', price: { min: 15000, max: 15000 } },
            ],
            status: 'available',
        }
    ],
    onRequest: [
        {
        id: 'pos',
        name: 'POS Systems',
        description: 'Point of sale systems for retail and hospitality.',
        },
        {
        id: 'lms',
        name: 'LMS / Training Platforms',
        description: 'Online learning and training management systems.',
        },
        {
        id: 'logistics',
        name: 'Logistics & Fleet Management',
        description: 'Delivery tracking, vehicle management, and driver coordination.',
        },
        {
        id: 'property',
        name: 'Property & Real Estate Management',
        description: 'Listings, tenant records, and maintenance request systems.',
        },
    ],
};

export const SERVICE_IMAGES = {
    'foundational-builds': 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=800',
    'ecommerce': 'https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg?auto=compress&cs=tinysrgb&w=800',
    'mobile-apps': 'https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=800',
    'ai-automation': 'https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=800',
    'api-integrations': 'https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=800',
    'mpesa-payments': 'https://images.pexels.com/photos/4386431/pexels-photo-4386431.jpeg?auto=compress&cs=tinysrgb&w=800',
    'dashboards': 'https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=800',
    'saas-mvp': 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800',
    'maintenance': 'https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg?auto=compress&cs=tinysrgb&w=800',
    'seo': 'https://images.pexels.com/photos/270637/pexels-photo-270637.jpeg?auto=compress&cs=tinysrgb&w=800',
};

export const PROJECTS = [
    {
        id: 'adopt-ai',
        name: ADOPTAFRICA,
        category: 'SaaS Platform',
        description: 'A managed AI operations platform that diagnoses, deploys, and manages AI tools for African businesses.',
        status: 'designed-built',
        tech: ['React', 'Node.js', 'Express', 'Supabase', 'Claude API'],
    //   url: 'https://adoptafrica.ai',
    //   url: 'https://adoptai.co',
        url: 'https://adoptafrica.co',
    },
];

export const STATUS_LABELS = {
    'designed-built': 'Designed & Built',
    'live':           'Live & Functioning',
    'in-development': 'In Development',
};